import React from 'react';
import styled from 'styled-components';
import Arrow from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { Nav } from '@catalogo/core-nav';
import { FooterItem } from './footer-item';

export const FooterContent = ({ highlightList }) => (
  <Container>
    <LinksList>
      {highlightList.map(item => (
        <FooterItem key={item._id} url={item.link} title={item.title} />
      ))}
    </LinksList>
    <MoreInfoLink to="#modal-more-info-footer">
      <span>mais informações</span>
      <ArrowIcon fill="#666" width="12px" height="12px" direction="right" />
    </MoreInfoLink>
  </Container>
);

const Container = styled.div`
  background-color: #f6f6f6;
  border-top: 3px solid #e5e5e5;
`;

const LinksList = styled.ul`
  list-style: none;
  margin: 0 auto;
  font-size: 0.875em;
`;

const MoreInfoLink = styled(Nav)`
  display: flex;
  justify-content: space-between;
  padding: 1.5em 1em;
  border-top: 3px solid #e5e5e5;
  font-size: 16px;
`;

const ArrowIcon = styled(Arrow)`
  transform: rotate(270deg);
`;
